import {GoldForm} from './GoldForm';

const GoldScreen = () =>{
  return(
    <div className={'w-full flex items-center justify-center lg:px-20 p-4'}>
      <div className={'flex flex-col justify-center'}>
        <h1 className={'lg:text-2xl text-lg font-semibold text-primary-900 font-serif-custom text-center'}>Sparkle with Us: Contact for Inquiries and Orders</h1>
        <GoldForm />
      </div>
    </div>
  );
};

export default GoldScreen;
